import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { type ReactNode, useMemo } from 'react';
import { createBtsisTheme } from './create-theme.js';

export type ThemeProviderProps = {
  children: ReactNode;
  mode?: 'light' | 'dark';
};

export function ThemeProvider({ children, mode = 'light' }: ThemeProviderProps) {
  const theme = useMemo(() => createBtsisTheme(mode), [mode]);
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
